import { latestCases } from './types';

export const requestLatestCases = (promise) => ({
  type: latestCases.request,
  promise,
});

export const requestLatestCasesSuccess = (response) => ({
  type: latestCases.success,
  response,
});

export const requestLatestCasesFailure = (error) => ({
  type: latestCases.failure,
  error,
});
